// Live-data limits and cache settings, in one place.

/** Weather cache cell: ~5.5 × 3.5 km at UK latitudes. Pubs in a cell share one forecast. */
export const WEATHER_CELL_DEG = 0.05;
/** Air quality comes from CAMS at ~10 km, so a coarser cell is plenty. */
export const AIR_CELL_DEG = 0.1;

export const WEATHER_TTL_MS = 60 * 60_000;
export const AIR_TTL_MS = 60 * 60_000;
/** Stale data older than this isn't worth showing even as a fallback. */
export const STALE_LIMIT_MS = 6 * 60 * 60_000;
export const HOLIDAYS_TTL_MS = 7 * 24 * 60 * 60_000;

/** LRU caps (entries per cache). A forecast cell is ~6 KB stored. */
export const WEATHER_CACHE_MAX = 80;
export const AIR_CACHE_MAX = 40;

/**
 * Hard per-session cap on Open-Meteo coordinate calls (each coordinate counts,
 * forecast and air quality separately). Previews and pins can use all but the
 * reserve, which is kept for pubs you open.
 */
export const SESSION_CALL_CAP = 300;
export const USER_RESERVE = 50;

export const FETCH_TIMEOUT_MS = 12_000;

/** Hover/tap preview waits this long before fetching. */
export const PREVIEW_DEBOUNCE_MS = 350;

/** Score pins: only when zoomed in this far, over this few weather cells. */
export const PINS_MIN_ZOOM = 13;
export const PINS_MAX_CELLS = 10;
/** And never more pubs than this at once (nearest the centre first). */
export const PINS_MAX_PUBS = 300;

/** Open-Meteo window: the hours before now (wet benches) and ahead (to end of tomorrow). */
export const PAST_HOURS = 6;
/** Air quality looks back a day for the DAQI's 24 h particulate means. */
export const AIR_PAST_HOURS = 24;
/** From the current hour, 48 hours always reaches 23:00 tomorrow. */
export const FORECAST_HOURS = 48;
